import { __awaiter } from "tslib";
import { getCurrentCfgObject, getSelectors } from "../reducers/selectors";
import { resetConfiguration } from "./resetConfiguration";
export function resetCurrentCfgObject() {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const cfgObject = getCurrentCfgObject(getState());
        const rootState = getState();
        const selectors = getSelectors(rootState);
        yield dispatch(resetConfiguration({
            path: cfgObject.path,
            selectors,
        }));
    });
}
//# sourceMappingURL=resetCurrentCfgObject.js.map